import { createAsyncThunk } from "@reduxjs/toolkit";

import { getResponseFormData } from "../selectors/getResponseFormSelectors";
import { getReadingDetailsData } from "../selectors/getReadingDetailsSelectors";

import type { ReadingMessage } from "@/entities/ReadingMessage";
import type { ThunkConfig } from "@/app/providers/StoreProvider";
import type { ApiError } from "@/shared/types";
import { handleError, safelyCaptureException } from "@/shared/lib/helpers/utils";

export const sendResponse = createAsyncThunk<ReadingMessage, File[], ThunkConfig<ApiError>>(
  "sendResponse",
  async (attachments, thunkApi) => {
    const { extra, dispatch, rejectWithValue, getState } = thunkApi;

    const readingDetails = getReadingDetailsData(getState());
    const formData = getResponseFormData(getState());

    const data = new FormData();
    data.append("reading_request", readingDetails.id);
    data.append("message", formData.messageText);
    data.append("personality", String(formData.writerPersonality));

    if (formData.tarotCard) {
      data.append("image_path", formData.tarotCard.imagePath);
      data.append("tarot", formData.tarotCard.tarot);
    }

    if (attachments.length) {
      const [selectedFile] = attachments;
      data.append("image", selectedFile);
    }

    try {
      const response = await extra.api.post<ReadingMessage>("/api/reading_responses", data);

      return response.data;
    } catch (err) {
      safelyCaptureException(err);

      return rejectWithValue(handleError(err));
    }
  }
);
